import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box, LinearProgress } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { H3 } from '../../../../layouts/TextStyles'
import { coursePriceApi } from '../../../../features/course/coursePrice'
import { topicApiSlice } from '../../../../features/topic/topicSlice'
import Search from '../../../../components/search'
import PurchaseCourseCard from './components/PurchaseCourseCard'
import TopicsTable from './components/TopicsTable'
import { Content, Header, Title, Wrapper, arrow, flexWrap } from './style'

const COURSE = 'course'
const TOPIC = 'topic'

const BuyCoursePage = () => {
    const { formatMessage, locale } = useIntl()
    const [filter, setFilter] = useState('')
    const [type, setType] = useState(COURSE)

    const { data: courses = [], isFetching: isFetchingCourses } =
        coursePriceApi.useFetchCoursesForPurchaseQuery()
    const [
        fetchfilteredTopics,
        { data: topics = null, isFetching: isFetchingTopics },
    ] = topicApiSlice.useLazyGetFilteredTopicsQuery()

    const handleSearchTopics = () => {
        setType(TOPIC)
        fetchfilteredTopics({ language: locale.toUpperCase(), filter })
    }

    return (
        <Wrapper>
            {type === TOPIC && (
                <ArrowBack
                    sx={arrow}
                    onClick={() => setType(COURSE)}
                />
            )}

            <Content>
                <Header style={{ marginBottom: '16px' }}>
                    <Title>
                        <H3>{formatMessage({ id: 'purchase' })}</H3>
                    </Title>

                    <Box>
                        <Search
                            textValue={filter}
                            placeholder={formatMessage({ id: 'searchByTopic' })}
                            onSearch={handleSearchTopics}
                            onChangeText={(text: string) => setFilter(text)}
                        />
                    </Box>
                </Header>

                {isFetchingCourses || isFetchingTopics ? (
                    <LinearProgress />
                ) : type === COURSE ? (
                    courses.length ? (
                        <Box sx={flexWrap}>
                            {courses.map((course) => (
                                <PurchaseCourseCard
                                    coursePurchase={course}
                                    key={course.id}
                                />
                            ))}
                        </Box>
                    ) : (
                        formatMessage({ id: 'noData' })
                    )
                ) : (
                    <TopicsTable topics={topics} />
                )}
            </Content>
        </Wrapper>
    )
}

export default BuyCoursePage
